/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFZoomyDomainConfidenceMapScoreItem } from './CRSFZoomyDomainConfidenceMapScoreItem';
import {
    CRSFZoomyDomainConfidenceMapScoreItemFromJSON,
    CRSFZoomyDomainConfidenceMapScoreItemFromJSONTyped,
    CRSFZoomyDomainConfidenceMapScoreItemToJSON,
} from './CRSFZoomyDomainConfidenceMapScoreItem';

/**
 * 
 * @export
 * @interface CRSFZoomyDomainConfidenceMapScore
 */
export interface CRSFZoomyDomainConfidenceMapScore {
    /**
     * 
     * @type {number}
     * @memberof CRSFZoomyDomainConfidenceMapScore
     */
    confidence: number;
    /**
     * 
     * @type {CRSFZoomyDomainConfidenceMapScoreItem}
     * @memberof CRSFZoomyDomainConfidenceMapScore
     */
    detailed_score: CRSFZoomyDomainConfidenceMapScoreItem;
}

/**
 * Check if a given object implements the CRSFZoomyDomainConfidenceMapScore interface.
 */
export function instanceOfCRSFZoomyDomainConfidenceMapScore(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidence" in value;
    isInstance = isInstance && "detailed_score" in value;

    return isInstance;
}

export function CRSFZoomyDomainConfidenceMapScoreFromJSON(json: any): CRSFZoomyDomainConfidenceMapScore {
    return CRSFZoomyDomainConfidenceMapScoreFromJSONTyped(json, false);
}

export function CRSFZoomyDomainConfidenceMapScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFZoomyDomainConfidenceMapScore {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidence': json['confidence'],
        'detailed_score': CRSFZoomyDomainConfidenceMapScoreItemFromJSON(json['detailed_score']),
    };
}

export function CRSFZoomyDomainConfidenceMapScoreToJSON(value?: CRSFZoomyDomainConfidenceMapScore | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence': value.confidence,
        'detailed_score': CRSFZoomyDomainConfidenceMapScoreItemToJSON(value.detailed_score),
    };
}

